module.exports = function getResource(label, vars = []) {
    const resources = { moreCleanBeautyTitle: 'Plus de produits purs et sains' };
    return resources[label];
};
